import { IVideo, PlayerType } from '../models/video';

export const getVideoConfig = (resolutionVideo: IVideo) => {
  const playerType = getPlayerType(resolutionVideo);
  const token = getVideoToken(playerType, resolutionVideo);

  return {
    playerType,
    token,
    hasToken: token !== '',
  };
};

/**
 * Resolução de exercício com o Player AWS em primeiro lugar. Com o id AWS,
 * toca por ele; só com o Vimeo ID, o player pergunta ao backend se esse vídeo
 * já está no Player AWS e, se não estiver, toca o Vimeo como sempre. O vínculo
 * do exercício não muda. Sambatech e YouTube seguem como estão.
 *
 * Só para resolução: aulas (Cursos) continuam em getVideoConfig.
 */
export const getResolutionVideoConfig = (resolutionVideo: IVideo) => {
  const config = getVideoConfig(resolutionVideo);
  const playerType: PlayerType =
    config.playerType === 'vimeo' ? 'vimeoResolution' : config.playerType;
  // Player AWS com o Vimeo ID gravado ao lado: se o vídeo AWS não abrir, toca
  // o Vimeo (o vínculo antigo continua valendo).
  const vimeoID = resolutionVideo?.vimeoID;
  const fallbackToken =
    playerType === 'awsResolution' &&
    vimeoID &&
    !['.', 'teste', '0'].includes(vimeoID)
      ? vimeoID
      : undefined;

  return { ...config, playerType, fallbackToken };
};

const getPlayerType = (resolutionVideo: IVideo): PlayerType => {
  if (
    resolutionVideo?.defaultPlayer === 'youtube' ||
    (resolutionVideo?.player === 'youtube' && resolutionVideo?.youtubeUrl)
  ) {
    return 'youtube';
  }

  // Resolução vinculada ao Player AWS. Sem o id AWS, segue a regra antiga
  // (o Vimeo ID gravado ao lado continua tocando pelo Vimeo).
  if (
    (resolutionVideo?.defaultPlayer === 'aws' ||
      resolutionVideo?.player === 'aws') &&
    resolutionVideo?.videoPlatformId
  ) {
    return 'awsResolution';
  }

  if (resolutionVideo?.vimeoID && resolutionVideo?.vimeoID !== '.' && resolutionVideo?.vimeoID !== 'teste') {
    return 'vimeo';
  }

  if (
    resolutionVideo?.defaultPlayer === 'samba' ||
    resolutionVideo?.player === 'samba'
  ) {
    return 'sambatech';
  }

  return (
    resolutionVideo?.defaultPlayer ?? resolutionVideo?.player ?? 'sambatech'
  );
};

const getVideoToken = (
  playerType: PlayerType,
  resolutionVideo: IVideo
): string => {
  const token = playerType === 'vimeo' && resolutionVideo.vimeoID
  ? resolutionVideo.vimeoID
  : playerType === 'sambatech' && resolutionVideo?.sambatech_token
    ? resolutionVideo.sambatech_token
    : playerType === 'youtube' && resolutionVideo?.youtubeUrl
      ? resolutionVideo.youtubeUrl
      : playerType === 'awsResolution' && resolutionVideo?.videoPlatformId
        ? resolutionVideo.videoPlatformId
        : '';

  return token === '0' ? '' : token;
};
